(function () {
  function setup() {
    var triggers = document.querySelectorAll('[data-claude-alma-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.claudeAlmaBound === '1') return;
      trigger.dataset.claudeAlmaBound = '1';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = trigger.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        var isHidden = target.hasAttribute('hidden');
        if (isHidden) {
          target.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          target.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
